module.exports = __webpack_public_path__ + "static/media/exit.185759c5.svg";